import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Project } from '@src/app/models/project';
import { ProjectvisibilitytoggleService } from './service/projectvisibilitytoggle.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projectvisibilitytoggle',
  templateUrl: './projectvisibilitytoggle.component.html',
  styleUrls: ['./projectvisibilitytoggle.component.css']
})
export class ProjectvisibilitytoggleComponent implements OnChanges, OnInit {
  @Input() project:Project;
  setActiveStateProject:Project;
  successenable:boolean; 
  successdisable:boolean;
  
  @ViewChild('closeDisablemodal',{static: true}) closeDisablemodal: ElementRef;
 
 
  constructor(private tlsrv:ProjectvisibilitytoggleService) { }
  ngOnInit(): void {
    this.setActiveStateProject = this.project;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.project && changes.project.currentValue){
      this.setActiveStateProject = changes.project.currentValue;
    }
  }


  setActiveState(project:Project){
    if(project.isactive == undefined){
      project.isactive = true;
    }
    this.setActiveStateProject = project;
  }
  disableProject(){

      this.setActiveStateProject.isactive = false;
    this.tlsrv.updateProject(this.setActiveStateProject).pipe(untilDestroyed(this)).subscribe(p =>{

    });
    this.successenable = false; 
  this.successdisable = true; 
  setTimeout(() => {
    this.closeDisablemodal.nativeElement.click();
  }, 100);  }
  activateProject(){

    this.setActiveStateProject.isactive = true;
    this.tlsrv.updateProject(this.setActiveStateProject).pipe(untilDestroyed(this)).subscribe(p =>{
      
    });
    this.successdisable = false; 
    this.successenable = true; 
    setTimeout(() => {
      this.closeDisablemodal.nativeElement.click();
    }, 100);
  }
}
